import { authHelper } from "@/utils/helpers";
import axios from "axios";

class Api {
  // eslint-disable-next-line class-methods-use-this
  call(requestType, url, data = null) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-undef
      axios[requestType](url, data)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          if (
            (err.response && err.response.status === 401) ||
            err.response.status === 503
          ) {
            authHelper.logout();
          }
          if (url.includes("/import/products")) {
            window.notify({
              message: err.response.data.message,
              type: "danger",
              title: "Error!"
            });
          } else if (err.response.status === 422) {
            reject(err);
          } else {
            console.log(err.response.data);
            err.response.data.details.forEach(i => {
              window.notify({
                message: i.message,
                type: "danger",
                title: "Error!"
              });
            });
          }
          reject(err);
        });
    });
  }
}

export default Api;
